import { gql } from '@apollo/client'

export const TRAINING_FRAGMENT = gql`
  fragment Training on Training {
    title
    description
    id
    timeRequired
    groups {
      id
      name
    }
    keyTakeaways
    deviceType
    trainingImage {
      id
      url
      bucketFileName
    }
    videoUrl
  }
`
